import { ref, onMounted, computed, watch, watchEffect, nextTick } from 'vue'
import formHelper from '../utils/form-helper.js'

export function watchAdsCountryChangePlugin(form$) {
    const form = form$?.value;

    //verify we have a form and a country value in the form data
    if (!form || typeof (form.data?.country) == 'undefined') {
        return;
    }

    //find the element id of the location group
    //if there are multiple ones, return the first we find
    const locationElements = form.flatTree.filter(x => x == "location" || x.endsWith('.location'));
    if (locationElements.length == 0) {
        return;
    }
    const locationGroupFullName = locationElements[0];


    //find the schema for the elements we care about
    const { schema: countrySchema, path: countryPath } = formHelper.findChildSchemaAndPath(form, locationGroupFullName, "country");
    const { schema: stateSchema, path: statePath } = formHelper.findChildSchemaAndPath(form, locationGroupFullName, "state");
    const { schema: countySchema, path: countyPath } = formHelper.findChildSchemaAndPath(form, locationGroupFullName, "county");


    //verify we have a location group schema with at least a state inside
    if (!countrySchema || !stateSchema) {
        return;
    }

    const stateRequired = stateSchema?.rules?.includes('required') ?? false;
    const countyRequired = countySchema?.rules?.includes('required') ?? false;

    console.log("VFP: ccp: country change plugin enabled.");

    //watch for country changes to modify labels
    watch(() => form.data.country, () => {
        if (form.data.country == "United States") {
            stateSchema.label = { "en": 'State', "fr_CA": "État" };
            stateSchema.placeholder = getPlaceholderFromLabel(stateSchema.label, stateRequired);
            if (countySchema) {
                countySchema.label = { "en": 'County', "fr_CA": "Comté" };
                countySchema.placeholder = getPlaceholderFromLabel(countySchema.label, countyRequired);
            }
        } else if (form.data.country == "Canada") {
            stateSchema.label = { "en": "Province", "fr_CA": "Province" };
            stateSchema.placeholder = getPlaceholderFromLabel(stateSchema.label, stateRequired);
            if (countySchema) {
                countySchema.label = { "en": 'Region', "fr_CA": "Région" };
                countySchema.placeholder = getPlaceholderFromLabel(countySchema.label, countyRequired);
            }
        } else {
            stateSchema.label = { "en": "State/Provice", "fr_CA": "État/Province" };
            stateSchema.placeholder = getPlaceholderFromLabel(stateSchema.label, stateRequired);
            if (countySchema) {
                countySchema.label = { "en": "County/Region", "fr_CA": "Comté/Région" };
                countySchema.placeholder = getPlaceholderFromLabel(countySchema.label, countyRequired);
            }
        }

    }, { immediate: true });

    //watch for state to load with empty counties so we can disable that field
    //and allow it to submit even if its normally required

    if (countySchema) {
        const stateVue = form.el$(statePath);
        const countyVue = form.el$(countyPath);
        if (stateVue && countyVue) {

            console.log("VFP: ccp: watching for empty county lists")

            let countyIsRequired = countySchema.rules?.includes('required') ?? false;

            //when the county 'change'd see if state is set to something, and verify if county has any values to select
            countyVue.$watch("input.eo", (eo) => {
                if (eo.length > 1 || (eo.length === 1 && eo[0].value !== '')) {
                    enable(countyVue, countySchema, countyIsRequired);
                } else {
                    if (stateVue.value) {
                        disable(countyVue, countySchema, countyIsRequired);
                    } else {
                        enable(countyVue, countySchema, countyIsRequired);
                    }
                }

            });
        } else {
            console.log("VFP: ccp: Couldn't track county emptiness.")
        }
    }

    function getPlaceholderFromLabel(label, required) {
        const placeHolder= { "en": label.en + (required ? "*" : ""), "fr_CA": label.fr_CA + (required ? "*" : "" )};
        return placeHolder;
    }

    function disable(element, schema, isRequired) {

        if (isRequired) {
            const index = schema?.rules?.indexOf('required') ?? -1;
            if (index > -1) {
                schema.rules.splice(index, 1);
            }
        }

        nextTick(() => {
            element.reinitValidation();
            element.disable();
        });

    }

    function enable(element, schema, isRequired) {

        if (isRequired) {
            const index = schema?.rules?.indexOf('required') ?? 0;
            if (index == -1) {
                schema.rules.push('required');
            }
        }

        nextTick(() => {
            element.reinitValidation();
            element.enable();
        });

    }


}